<!-- DS StatusToolbar: right-aligned row, gap 22, 32px hairline dividers between
     [buttons] | [date] | [weather] on the page background, border-strong
     dividers; text inherits the surrounding ink via currentColor. -->
<div class="flex items-center gap-3 text-current md:gap-[22px]" *transloco="let t">
  <div class="flex items-center gap-3 md:gap-[22px]">
    @if (inAdminPortal()) {
      <app-notifications-button (activated)="notificationsClicked.emit()" />
    } @else {
      <app-alert-bell />
    }

    <app-icon-button
      icon="icon-search"
      [label]="t('statusToolbar.search')"
      (activated)="searchClicked.emit()"
    />
  </div>

  <!-- Informational tail collapses on small screens: date needs md, weather lg. -->
  <span class="hidden h-8 w-px shrink-0 bg-strong md:block" aria-hidden="true"></span>

  <span class="text-body-1 hidden whitespace-nowrap md:inline">{{ now() }}</span>

  @if (weather.enabled) {
    <span class="hidden h-8 w-px shrink-0 bg-strong lg:block" aria-hidden="true"></span>

    <app-weather class="hidden lg:block" />
  }
</div>
